import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';
import _sum from 'lodash/sum';

import { SPACE, COLOR } from '../../Theme';
import fillArray from '../../../Util/fillArray';
import { Text, SplitScore, Number } from '../../Base';
import DiagonalTableCell from './DiagonalTableCell';
import { Table, TableHead, TableBody, TableFooter, TableRow, TableCell } from '../TableComponents';

const TableHeaderSection = ({ examTitle }) => (
  <TableHead>
    <TableRow cellBorder={true} bgColor={COLOR.gridGrey}>
      <TableCell minWidth={'135px'} maxWidth={'200px'} rowSpan={2}>
        <DiagonalTableCell left={'คะแนน'} right={'การสอบ'} />
      </TableCell>
      <TableCell colSpan={2} wrap={true} textAlign={'center'}>
        {examTitle}
      </TableCell>
    </TableRow>
    <TableRow cellBorder={true} bgColor={COLOR.gridGrey}>
      <TableCell textAlign={'center'}>จำนวนคน</TableCell>
      <TableCell wrap={true} textAlign={'center'}>
        คิดเป็นร้อยละ
      </TableCell>
    </TableRow>
  </TableHead>
);

const TableBodySection = ({ score, rows, columns, percentageColumns, color }) => (
  <TableBody>
    {rows.map((row, index) => {
      const fontColor = score.columnIndex === index && COLOR.white;
      return (
        <TableRow
          key={index}
          cellBorder={true}
          bgColor={score.columnIndex === index ? color : 'inherit'}
        >
          <TableCell color={fontColor}>
            <SplitScore
              score={row[0]}
              fullScore={row[1]}
              seperator={'-'}
              variant="other"
              color={'inherit'}
            />
          </TableCell>
          <TableCell color={fontColor}>
            <Number value={columns[index]} textAlign={'center'} />
          </TableCell>
          <TableCell color={fontColor}>
            <Number value={percentageColumns[index]} textAlign={'center'} />
          </TableCell>
        </TableRow>
      );
    })}
  </TableBody>
);

const TableFooterSection = ({ columns }) => (
  <TableFooter>
    <TableRow cellBorder={true} bgColor={COLOR.gridGrey}>
      <TableCell>รวม(คน)</TableCell>
      <TableCell>
        <Number value={_sum(columns)} textAlign={'center'} />
      </TableCell>
      <TableCell>
        <Number value={100} textAlign={'center'} />
      </TableCell>
    </TableRow>
  </TableFooter>
);
const ScoreRangeTableVertical = ({
  columns,
  studentCountRow,
  percentageRow,
  score,
  examTitle,
  title,
  themeColor,
}) => {
  const rowCount = columns.length;
  const formattedPercentageColumns = fillArray(percentageRow, rowCount);
  const formattedColumns = fillArray(studentCountRow, rowCount);

  return (
    <Box>
      <Text.Subtitle mb={SPACE.medium}>{title}</Text.Subtitle>
      <Box style={{ overflowX: 'auto' }}>
        <Table padding={'checkbox'} border>
          <TableHeaderSection examTitle={examTitle} />
          <TableBodySection
            score={score}
            rows={columns}
            columns={formattedColumns}
            percentageColumns={formattedPercentageColumns}
            color={themeColor}
          />
          <TableFooterSection columns={formattedColumns} />
        </Table>
      </Box>
    </Box>
  );
};

ScoreRangeTableVertical.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.array,
  studentCountRow: PropTypes.array,
  percentageRow: PropTypes.array,
  score: PropTypes.object,
  examTitle: PropTypes.string,
  themeColor: PropTypes.string,
};

ScoreRangeTableVertical.defaultProps = {
  columns: [],
  studentCountRow: [],
  percentageRow: [],
  score: {},
};

export default ScoreRangeTableVertical;
